import type { ReactNode } from "react";

import notDataImage from "@/views/assets/images/notData.png";

export interface AdminTableEmptyProps {
    /** 空态下方的提示文案，允许适配器保留业务页面的自定义文案。 */
    text?: ReactNode;
}

/** 统一复用旧 Vue ProTable 的 notData.png 空表展示。 */
export function AdminTableEmpty({ text = "暂无数据" }: AdminTableEmptyProps) {
    return (
        <div className="admin-table-empty">
            <img src={notDataImage} alt="暂无数据" />
            <div>{text}</div>
        </div>
    );
}

export default AdminTableEmpty;
